import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=241e4f8c&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"
import style0 from "./phone.vue?vue&type=style&index=0&id=241e4f8c&prod&scoped=true&lang=less"
import style1 from "./phone.vue?vue&type=style&index=1&id=241e4f8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e4f8c",
  null
  
)

export default component.exports